/**
 * @(#)2019/11/18.
 * YxOffice 通过调用微软方法，实现预览office套件的组件
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./index.less";
import React from "react";
import defaultProps from "./param";
// import FileViewer from 'react-file-viewer'
import { get, random } from "../../utils/index";
import { YxComponent, Connection } from "../YxComponent";

@Connection(defaultProps)
class YxOffice extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {};
    this.ident = random();
  }

  get viewUrl() {
    const url = get(this.props, ["url", "src"], null);
    if (url == null) {
      return null;
    }
    return `https://view.officeapps.live.com/op/view.aspx?src=${url}`;
  }

  render() {
    const url = get(this.props, ["url", "src"], null);
    return (
      <div className={`yx_office ${this.ident}`}>
        {/* <iframe src={this.viewUrl}></iframe> */}
        <FileViewer fileType="xlsx" filePath={url}></FileViewer>
      </div>
    );
  }
}

export default YxOffice;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxOffice/index.js